/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_GradesInputs */

const en_gc_editor_grades = /** @type {(inputs: Gc_Editor_GradesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade tracker`)
};

const zh_gc_editor_grades = /** @type {(inputs: Gc_Editor_GradesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成绩记录`)
};

/**
* | output |
* | --- |
* | "Grade tracker" |
*
* @param {Gc_Editor_GradesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_grades = /** @type {((inputs?: Gc_Editor_GradesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_GradesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_grades(inputs)
	return zh_gc_editor_grades(inputs)
});
export { gc_editor_grades as "gc.editor.grades" }